import { Link, Text, VStack } from '@chakra-ui/react';

const PATIENT_APP_PROFILE_URL = 'https://app.berrystreet.com/profile';
const GLP_1_PROGRAM_URL =
  'https://community.berrystreet.co/c/general/our-glp-1-program-why-berry-street-is-the-best-path-for-your-patients';

export const GlpProgramAnnouncementInfo = () => {
  return (
    <VStack align="start" spacing={1}>
      <Text fontWeight="semibold">
        Berry Street is now prescribing GLP-1s!
      </Text>
      <Text>
        If your patient is a good fit, direct them to the GLP-1 Intake flow at{' '}
        <Link
          href={PATIENT_APP_PROFILE_URL}
          isExternal
          color="text.brand"
          textDecoration="underline"
        >
          app.berrystreet.com/profile
        </Link>
        . Read more{' '}
        <Link
          href={GLP_1_PROGRAM_URL}
          isExternal
          color="text.brand"
          textDecoration="underline"
        >
          here
        </Link>
        .
      </Text>
    </VStack>
  );
};
